import { guessCurrentTimeZone } from 'utils/timeZone';
import { DateParams, TimePreset, TimePresetContext } from 'modules/iterableGoals/types';
import { DAY, getMonthsAgo, getNewDate } from 'utils/date';

export const RELATIVE_TIME_PRESETS: Record<TimePreset, TimePresetContext> = {
  PAST_30_DAYS: {
    menuLabel: 'timePresets.menu.30Days',
    filterLabel: 'timePresets.filter.30Days',
    format: (timeZone) => ({
      startDate: getMonthsAgo(getNewDate({ timeZone }), 1).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  PAST_60_DAYS: {
    menuLabel: 'timePresets.menu.60Days',
    filterLabel: 'timePresets.filter.60Days',
    format: (timeZone) => ({
      startDate: getMonthsAgo(getNewDate({ timeZone }), 2).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  PAST_90_DAYS: {
    menuLabel: 'timePresets.menu.90Days',
    filterLabel: 'timePresets.filter.90Days',
    format: (timeZone) => ({
      startDate: getMonthsAgo(getNewDate({ timeZone }), 3).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  CUSTOM_RANGE: {
    menuLabel: 'timePresets.menu.custom',
    filterLabel: 'timePresets.filter.custom',
  },
};

export const defaultTimePreset = TimePreset.PAST_30_DAYS;
export const defaultTimezone = guessCurrentTimeZone();
export const defaultDateParams: DateParams = RELATIVE_TIME_PRESETS[defaultTimePreset]?.format?.(
  defaultTimezone,
) ?? {
  startDate: getMonthsAgo(getNewDate({ timeZone: defaultTimezone }), 1).startOf(DAY),
  endDate: getNewDate({ timeZone: defaultTimezone }).endOf(DAY),
};
